import PensiveRobotSvg from '@/assets/PensiveRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import DialogMobile from '@/components/dialog/DialogMobile.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { ErrorsMessageProps } from '@/views/errors/components/ErrorsMessageDesktop.tsx';
import React from 'react';

const ErrorsMessageMobile: React.FC<ErrorsMessageProps> = ({ handleBack }) => {
  const { t } = useTranslationWithPrefix('views.errors');
  return (
    <div className="flex flex-column">
      <DialogMobile
        image={
          <img
            alt="love-robot"
            className="object-cover w-75 align-self-end"
            src={generateNonCachableImageSrc(PensiveRobotSvg)}
          />
        }
        message={t('basic.title')}
      />
      <ButtonWithLoading onClick={handleBack}>{t('buttons.back')}</ButtonWithLoading>
    </div>
  );
};

export default ErrorsMessageMobile;
